import ApiService from '@/services/core/api.service'

const PendingService = {
  async get (query = '') {
    return ApiService.get(`cash-management-officer/check-approvals?${query}`)
  },

  async post (payload) {
    return ApiService.post('cash-management-officer/check-approvals', payload)
  },

  async put (payload) {
    return ApiService.put(`cash-management-officer/check-approvals/${payload.id}`, payload)
  },

  async delete (payload) {
    return ApiService.delete(`cash-management-officer/check-approvals/${payload.id}`)
  }
}

export default PendingService
